import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../common/TextInput';
import EmailInput from '../common/EmailInput';
import NumberInput from '../common/NumberInput';

const MandatoriesForm = ({ user, onSave, onChange, loading, errors }) => {
	return (

		<form className="mandatories-form">

			<TextInput
				name="company"
				label="Company Name"
				value={user.company}
				onChange={onChange}
				error={errors.company} />

			<NumberInput
				name="associates"
				label="Number of Associates(Set to 1 for Healthcare Calculator)"
				value={user.associates}
				onChange={onChange}
				error={errors.associates} />

			<TextInput
				name="contactName"
				label="Client Contact"
				value={user.contactName}
				onChange={onChange}
				error={errors.contactName} />

			<EmailInput
				name="contactEmail"
				label="Client Email"
				value={user.contactEmail}
				onChange={onChange}
				error={errors.contactEmail} />


			<TextInput
				name="contactPhone"
				label="Client Phone"
				value={user.contactPhone}
				onChange={onChange}
				error={errors.contactPhone} />

			<hr />
			<TextInput
				name="projectName"
				label="Project Name"
				value={user.projectName}
				onChange={onChange}
				error={errors.projectName} />

			<NumberInput
				name="projectSqFt"
				label="Project SqFt"
				value={user.projectSqFt}
				onChange={onChange}
				error={errors.projectSqFt}
				className="sm" />

			<hr />

			<TextInput
				name="representitiveName"
				label="BSI Representative"
				value={user.representitiveName}
				onChange={onChange}
				error={errors.representitiveName} />

			<EmailInput
				name="representitiveEmail"
				label="BSI Representative Email"
				value={user.representitiveEmail}
				onChange={onChange}
				error={errors.representitiveEmail} />

			<div className='form-group'>
				<label htmlFor='notes'>Notes/Scope</label>
				<div className="field">
					<textarea
						name="notes"
						onChange={onChange}
						error={errors.notes}
						value={user.notes} />
				</div>
			</div>


			<input
				type="submit"
				disabled={loading}
				value={loading ? "Saving..." : 'Next'}
				className="btn large"
				onClick={onSave} />
		</form>
	);
};

MandatoriesForm.propTypes = {
	user: PropTypes.object,
	onSave: PropTypes.func,
	onChange: PropTypes.func,
	loading: PropTypes.bool,
	errors: PropTypes.object
};

export default MandatoriesForm;



// WEBPACK FOOTER //
// ./src/components/mandatories/MandatoriesForm.js